import { FC } from 'react'
import { IManualSuscriptionVia } from '../../../../common/interfaces'

interface IProps {
  vias: IManualSuscriptionVia[]
  value: number | ''
  onChange: (viaId: number | '') => void
  loading?: boolean
}

export const ViaSelect: FC<IProps> = ({ vias, value, onChange, loading }) => (
  <div className='col-lg-6 mb-7'>
    <label htmlFor='via' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
      Via
      {loading && <span className='spinner-border spinner-border-sm text-primary' role='status' />}
    </label>
    <select
      id='via'
      className='selectForm contract-select-toggle'
      value={value}
      disabled={loading}
      onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
    >
      <option value=''>Seleccione</option>
      {vias.map((via) => (
        <option key={via.id} value={via.id}>
          {via.description}
        </option>
      ))}
    </select>
  </div>
)
